import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
  OnInit, ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { BrandInformationService } from '../../brand-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { BrandService } from 'shared/brand/brand.service';
import { CoreService } from 'shared/global-core/core.service';
import { BaseSegmentComponent } from '../base/_base-segment.component';
import { CoreFormComponent } from './core-form.component';
import { CORE_NAME } from '../../variables';
import { PermissionsService } from 'shared/permissions/permissions.service';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';
import {BRAND_NAME} from '../../../account-information/variables';


@Component({
  moduleId: module.id,
  selector: 'core-segment',
  template: `
    <core-form
      [data]='data'
      [segmentData]='segmentData'
      [savingEvents]="coreService.isSavedObservable"
      (cancel)='cancelClickHandler()'
      (saveChanges)='saveChangesClickHandler()'
    ></core-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreComponent extends BaseSegmentComponent implements OnInit {
  name: string = CORE_NAME;

  @ViewChild(CoreFormComponent, {static: true})
  // @ts-ignore
  protected formComponent: CoreFormComponent;

  constructor(
    public coreService: CoreService,
    protected router: Router,
    protected brandInformationService: BrandInformationService,
    protected informationPageService: InformationPageService,
    protected brandService: BrandService,
    protected permissionsService: PermissionsService,
    protected ref: ChangeDetectorRef,
  ) {
    super(
      router,
      brandInformationService,
      informationPageService,
      permissionsService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
  }


  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  fetchFormData(): Observable<any> {
    return this.coreService.fetch(this.brandService.getBrand());
  }

  putFormData(): Observable<any> {
    const data = this.formComponent.core.value;
    return this.coreService.put(this.brandService.getBrand(), data);
  }

  cancelClickHandler() {
    this.informationPageService.emitCancel(BRAND_NAME);
  }

  saveChangesClickHandler() {
    this.informationPageService.emitShowBeforeSaveModal();
  }

  onSaved(event: any) {
    this.coreService.emitIsSaved();
  }

  protected showLoader() {
    this.formComponent.loader.show();
  }

  protected hideLoader() {
    this.formComponent.loader.hide();
  }
}
